import { TiptapControl } from "@mzara/component"
import { useKanbanTiptapSuggestions } from "views/kanban/views/details/hooks/useKanbanTiptapSuggestions"
import '../css/appointment.css'

export const AppointmentTiptapEditor = (props: AppointmentTiptapEditorProps) => {


    const suggestions = useKanbanTiptapSuggestions(props.boardId)

    return (
        <TiptapControl
            readonly
            className={`appointment-tiptap-editor`}
            value={props.value}
            suggestions={suggestions}
            />
    )
}

export type AppointmentTiptapEditorProps = {
    boardId: number
    value: string
}
